import {useCallback, useEffect, useState} from "react";
import {ArrowUpward} from "@mui/icons-material";
import {Box, Fab, Zoom} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import Chatbot from "../ai-assistant-chatbot";
import {nodeIdSelector} from "../../state/node/nodeSelectors";

const FabGroup = () => {
  const {t} = useTranslation();

  const nodeId = useSelector(nodeIdSelector);

  const [scrollTopVisibility, setScrollTopVisibility] = useState(false);

  const handleScroll = useCallback(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 50) {
      setScrollTopVisibility(true);
    } else {
      setScrollTopVisibility(false);
    }
  }, []);

  const scrollTop = () => {
    window.scroll({top: 0, left: 0, behavior: "smooth"});
  };

  useEffect(() => {
    window.scroll({top: 0, left: 0});
    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    handleScroll();
  });

  return (
    <Box
      className="fab-group"
      sx={{
        position: "fixed",
        right: "16px",
        bottom: "56px",
        zIndex: theme => theme.zIndex.appBar,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px"
      }}
    >
      <Zoom in={scrollTopVisibility}>
        <Fab
          className="page__scroll-to-top__fab"
          color="secondary"
          onClick={scrollTop}
          aria-label={t("components.page.actions.goBackToTop")}
        >
          <ArrowUpward />
        </Fab>
      </Zoom>
      {nodeId && <Chatbot />}
    </Box>
  );
};

export default FabGroup;
